const defaultState={
    waiting:false,
    result: undefined,
    productsOn: false,
    error: undefined
};

export default (state=defaultState, action)=>{
    // console.log(action);
    switch (action.type){
        case 'SEND':
            return {
                ...state,
                waiting: true,
                result:undefined,
                error: undefined
            };
        case 'GOT_RESPONSE':
            return {
                ...state,
                result:action.result,
                waiting:false
            };
        case 'EXPECT_RESULT':
            return {
                ...state,
                result:action.result,
            };
        case 'GOT_OTHER':
            return {
                ...state,
                waiting: false
            };
        case 'GOT_ERROR':
            return {
                ...state,
                waiting: false,
                error: action.error
            };
        case 'OPEN_PRODUCTS':
            return {
                ...state,
                productsOn: true
            };
        case 'CLOSE_PRODUCTS':
            return {
                ...state,
                productsOn: false
            };
        default:
            return state;
    }
};
